import React from 'react';
import { Box, Typography } from '@mui/material';
import EscalationRoleSelector from './EscalationRoleSelector';
import EscalationUserSelector from './EscalationUserSelector';
import {
  formContainerStyles,
  getRoleSelectorBoxStyles,
  roleSelectorTitleStyles,
  noRolesTextStyles,
} from '../../../constants/escalateQueryDialog';

/**
 * EscalationForm Component
 * Main form container with role and user selectors
 */
const EscalationForm = ({
  roleOptions,
  selectedRole,
  selectedUserId,
  errors,
  onRoleChange,
  onUserChange,
}) => {
  const selectedRoleOption = roleOptions.find((option) => option.role === selectedRole);
  const hasError = Boolean(errors.role || errors.target);

  return (
    <Box sx={formContainerStyles}>
      <Box sx={getRoleSelectorBoxStyles(hasError)}>
        <Typography variant="body2" sx={roleSelectorTitleStyles}>
          Escalate this query to
        </Typography>
        {roleOptions.length > 0 ? (
          <>
            <EscalationRoleSelector
              roleOptions={roleOptions}
              selectedRole={selectedRole}
              errors={errors}
              onRoleChange={onRoleChange}
            />
            <EscalationUserSelector
              selectedRole={selectedRole}
              selectedRoleOption={selectedRoleOption}
              selectedUserId={selectedUserId}
              errors={errors}
              onUserChange={onUserChange}
            />
          </>
        ) : (
          <Typography variant="caption" sx={noRolesTextStyles}>
            No eligible escalation roles are available.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default EscalationForm;
